import React, { Fragment, useEffect, useRef, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LogoutUserAction } from "../../redux/actions/userActions";
import Avatar from "../images/avatar.png";
import Sort from "../images/sort.png";
import AdminSidebar from "./AdminSidebar";

const AdminHome = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const headerRef = useRef(null);

    const { isLoggedout, user, isAuthenticated } = useSelector(state => state.verifyEmailStore);
    const [showHeader, setShowHeader] = useState(false);

    const logoutUser = () => dispatch(LogoutUserAction());

    useEffect(() => {
        if (isLoggedout) {
            navigate("/login");
        }
        if (isAuthenticated && user && user.role !== "Admin") {
            navigate("/");
        }
        if (!isAuthenticated && !isLoggedout) {
            // still loading — do nothing
        }
    }, [isLoggedout, user, isAuthenticated, navigate]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (headerRef.current && !headerRef.current.contains(event.target)) {
                setShowHeader(false);
            }
        }
        if (showHeader) document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [showHeader]);

    if (!isAuthenticated || !user) return null;

    if (user.role !== "Admin") return null;

    return (
        <Fragment>
            <section className="flex justify-between">
                <AdminSidebar
                    user={user}
                    headerRef={headerRef}
                    showHeader={showHeader}
                    logoutUser={logoutUser}
                    handleClick={() => setShowHeader(false)}
                />

                <div className="w-[100%] transition-all duration-300">
                    <div className="w-[100%] fixed top-0 right-0 py-[1vmax] pl-[1.5vmax] pr-[1.5vmax] lg:pr-[2.5vmax] transition-all duration-300 z-[100] bg-[var(--color-1)]">
                        <div className="bg-white rounded-[1vmax] shadow-1 flex justify-between items-center min-h-[4vmax]">
                            <button
                                className="ml-[1vmax] flex-shrink-0 hover:translate-x-2 transition-transform duration-200"
                                onClick={() => setShowHeader(prev => !prev)}
                            >
                                <img src={Sort} alt="" className="w-[3vmax] lg:w-[2vmax]" />
                            </button>

                            <div className="flex items-center gap-[1vmax] pr-[1vmax] flex-shrink-0">
                                <div className="flex items-center gap-[0.8vmax]">
                                    <div className="w-[2.5vmax] h-[2.5vmax] rounded-full overflow-hidden flex-shrink-0">
                                        <img
                                            src={user?.avatar_url || Avatar}
                                            alt=""
                                            className="w-[2.5vmax] h-[2.5vmax] object-cover"
                                        />
                                    </div>
                                    <div className="flex flex-col min-w-0">
                                        <h3 className="text-[1.6vmax] lg:text-[1vmax] font-3 font-bold leading-tight whitespace-nowrap">{user?.name}</h3>
                                        <span className="text-[1.3vmax] lg:text-[0.75vmax] text-[#5f2dde] font-semibold whitespace-nowrap">{user?.role}</span>
                                    </div>
                                </div>
                                <button
                                    onClick={logoutUser}
                                    title="Logout"
                                    className="w-[3vmax] h-[3vmax] lg:w-[2vmax] lg:h-[2vmax] rounded-lg bg-red-50 hover:bg-red-100 text-red-500 flex items-center justify-center transition-colors flex-shrink-0"
                                >
                                    <i className="fa-solid fa-arrow-right-from-bracket text-[1.2vmax] lg:text-[0.85vmax]" />
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="pb-[9vmax] lg:pb-[7vmax]"></div>
                    <Outlet />
                </div>
            </section>
        </Fragment>
    );
};

export default AdminHome;
